<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap about-page">
        <div class="certificates-awards q-mb-lg">
            <h4>{{ certificates.title }}</h4>
            <div class="row q-col-gutter-xl">
                <div
                    v-for="(logo, index) in certificates.logos"
                    :key="index"
                    class="col-6 col-sm-4 col-md-3"
                >
                    <div class="team-img col-12">
                        <img :src="logo.image" alt="CFMA" />
                    </div>
                </div>
            </div>

            <h4>{{ awards.title }}</h4>
            <div class="row q-col-gutter-xl">
                <div
                    v-for="(logo, index) in awards.logos"
                    :key="index"
                    class="col-6 col-sm-4 col-md-3"
                >
                    <div class="team-img col-12">
                        <img :src="logo.image" alt="CFMA" />
                    </div>
                </div>
            </div>

            <h4>{{ partners.title }}</h4>
            <div class="row q-col-gutter-xl">
                <div
                    v-for="(logo, index) in partners.logos"
                    :key="index"
                    class="col-6 col-sm-4 col-md-3"
                >
                    <div class="team-img col-12">
                        <img :src="logo.image" alt="CFMA" />
                    </div>
                </div>
            </div>
        </div>
        <div class="notice-wrap">
            <span class="text-uppercase"
                >{{ $t('certificates.possible_partnership') }}:
                <a href="tel:+244 226 453 823">+244 226 453 823</a>
                {{ $t('general.or') }}
                <a href="mailto:info@cfma.co.ao">info@cfma.co.ao</a></span
            >
        </div>
    </div>
</template>

<script>
import PageLoading from '@/components/PageLoading'

const loadingKeys = {
    fetchingCertificates: 'fetching-certificates',
}

export default {
    name: 'AboutCertificates',

    components: {
        PageLoading,
    },

    data() {
        return {}
    },

    computed: {
        certificates() {
            return {
                title: this.$t('general.certifications'),
                logos: [
                    {
                        image: require('@/assets/images/certificates/inefop.png'),
                    },
                    {
                        image: require('@/assets/images/certificates/IMO.png'),
                    },
                    {
                        image: require('@/assets/images/certificates/345.png'),
                    },
                ],
            }
        },

        awards() {
            return {
                title: this.$t('general.awards'),
                logos: [
                    {
                        image: require('@/assets/images/awards/ILHAS-MARSHAL.png'),
                    },
                    {
                        image: require('@/assets/images/awards/jomiremop.png'),
                    },
                    {
                        image: require('@/assets/images/awards/LIBERIA.png'),
                    },
                    {
                        image: require('@/assets/images/awards/VENUET.png'),
                    },
                ],
            }
        },

        partners() {
            return {
                title: this.$t('general.pedagogical_partnerships'),
                logos: [
                    {
                        image: require('@/assets/images/partners/logos/bay.png'),
                    },
                    {
                        image: require('@/assets/images/partners/logos/copper.png'),
                    },
                    {
                        image: require('@/assets/images/partners/logos/hdr.png'),
                    },
                    {
                        image: require('@/assets/images/partners/logos/inefop.png'),
                    },
                    {
                        image: require('@/assets/images/partners/logos/it.png'),
                    },
                    {
                        image: require('@/assets/images/partners/logos/ites.png'),
                    },
                ],
            }
        },

        isLoading() {
            return this.isFetchingCertificates
        },

        isFetchingCertificates() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingCertificates
            ).length
        },
    },
}
</script>
